import actions from './actions';

const initState = {
  users   : {
    data: []
  },
  userDeleted: false,
  userUpdated: false,
  loading : false,
};

export default function fetchUsersReducer(state = initState, action) {
    switch (action.type) {
        case actions.FETCH_USERS_REQUESTED:
            return {
                ...state,
                users   : {
                    data: []
                },
                loading : true
            };
        case actions.FETCH_USERS_SUCCEEDED:
            return {
                ...state,
                users       : action.users,
                loading     : false
            };
        case actions.FETCH_USERS_FAILED:
            return {
                ...state,
                loading : false
            };
        case actions.DELETE_USER_REQUESTED:
            return {
                ...state,
                loading : true
            };
        case actions.DELETE_USER_SUCCEEDED:
            return {
                ...state,
                loading     : false,
                userDeleted : true
            };
        case actions.DELETE_USER_FAILED:
            return {
                ...state,
                loading : false
            };
        default:
            return state;
    }
}
